import { IApplicationData } from 'src/interfaces/ApplicationData';
import { CSAT_EVENTS_BY_APPLICATION_ID } from './constants';
import CustomerFeedbackEntity from './entities/CustomerFeedbackEntity';
import { CustomerFeedbackGateway } from './gateways';
import { ICustomerFeedbackEventsData } from './interfaces/CustomerFeedbackGateway';

class CustomerFeedbackService {
  private readonly _customerFeedbackGateway: CustomerFeedbackEntity;
  private applicationData: IApplicationData;

  constructor(applicationData: IApplicationData) {
    this.applicationData = applicationData;
    const customerFeedbackGateway = new CustomerFeedbackGateway();
    this._customerFeedbackGateway = new CustomerFeedbackEntity(customerFeedbackGateway);
  }

  getCustomerFeedbackEventsByApplicationKey(): Promise<ICustomerFeedbackEventsData> {
    const { applicationData } = this;
    return CSAT_EVENTS_BY_APPLICATION_ID[applicationData.applicationKey] || {};
  }

  getCustomerFeedbackGateway() {
    return this._customerFeedbackGateway;
  }
}

export default CustomerFeedbackService;
